import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { App } from 'src/app/models/app';
import { UserLogin } from 'src/app/models/userlogin';
import { ApplicationHubService } from 'src/app/services/application-hub.service';
import { LoginService } from 'src/app/services/login.service';


@Component({
  selector: 'app-dial',
  templateUrl: './dial.component.html',
  styleUrls: ['./dial.component.scss']
})
export class DialComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private loginService: LoginService, private hubService: ApplicationHubService) {  }

  Apps: App[] = [];

  Production_Applications: App[] = [];
  Test_Applications: App[] = [];
  User: UserLogin | null = null;

  Filter: 'production' | 'test' = 'production';

  Loading = false;

  
  ngOnInit(): void {
    this.hubService.get()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.Apps = data;
        this.updateApplications();
      });
  
    this.loginService.User
      .pipe(takeUntil(this.destroy$))
      .subscribe((x) => {
        this.User = x;
        this.updateApplications();
      });
  }
  
  private updateApplications(): void {

    this.Loading = true;

    if (!this.Apps.length || !this.User) {
      return; // Wait until both Apps and User are available
    }
  
    this.Production_Applications = this.Apps.filter(
      (y) =>
        y.Production &&
        y.IdApplication !== undefined &&
        (this.User?.AppIdsToCheckForRoles?.includes(y.IdApplication) ||
        y.RoleRequired == false)
    );
  
    this.Test_Applications = this.Apps.filter(
      (y) =>
        !y.Production &&
        y.IdApplication !== undefined &&
        (this.User?.AppIdsToCheckForRoles?.includes(y.IdApplication) ||
        y.RoleRequired == false)
    );

    this.Loading = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}